import React, { useState } from "react";
import Utilities from "../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const util = new Utilities();

export default React.memo(ChatRoomItem);

const today = new Date();

function ChatRoomItem(props) {
  const {
    chat,
    loginInfo,
    searchText,
    addActiveChRoom,
    alertDisabledList,
    updateAlertDisable,
    openChangeChatRoomTitleModal,
    EVENT_SOCKET_TALK_LEAVE_ROOM,
  } = props;
  const { t } = useTranslation();
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  let msg = "";
  let chatUser = {};
  let userList = [];

  if (chat.hasOwnProperty("crmMainKey")) {
    for (let i = 0; i < chat.chatUserList.length; i++) {
      let user = chat.chatUserList[i];
      user.UserPIC =
        user.UserPIC || "https://freiscop.gbts.co.kr/images/user_pic-50x50.png";

      if (
        user.cruUserID === loginInfo.user_id &&
        user.cruUserSite === loginInfo.comp_cd
      ) {
        chatUser = user;
      } else {
        userList.push(user);
        if (user.cruUserID === chat.crmCreator) {
          msg = `${user.UserNICK ? user.UserNICK : user.UserName} ${t(
            "logiTalk.chatList.msg.requestChatting"
          )}`;
        }
      }
    }

    userList.push(chatUser);
    if (userList.length > 4) {
      userList = userList.slice(0, 4);
    }

    if (msg.indexOf("|¿|") > -1) {
      let msgSplit = msg.split("|¿|");
      msgSplit.splice(0, 3);
      msg = msgSplit.join("");
    }
    if (chat.crmLastMSG.indexOf("|¿|") > -1) {
      let msgSplit = chat.crmLastMSG.split("|¿|");
      msgSplit.splice(0, 3);
      chat.crmLastMSG = msgSplit.join("");
    }

    let displayTime = "";
    let crmLastTime = new Date(chat.crmLastTime);

    if (
      util.getDateToFormat(today, "YYYY.MM.DD") ===
      util.getDateToFormat(crmLastTime, "YYYY.MM.DD")
    ) {
      let condition = t("logiTalk.chatList.am");
      let hour = crmLastTime.getHours();
      if (hour > 12) {
        condition = t("logiTalk.chatList.pm");
        hour = hour - 12;
        hour = hour < 10 ? "0" + hour : hour;
      }
      displayTime = `${condition} ${hour}:${
        crmLastTime.getMinutes() < 10
          ? "0" + crmLastTime.getMinutes()
          : crmLastTime.getMinutes()
      }`;
    } else {
      displayTime = util.getDateToFormat(crmLastTime, "YYYY.MM.DD");
    }

    let isDisplay = true;
    if (searchText !== "" && chat.chatRoomTitle.indexOf(searchText) === -1) {
      isDisplay = false;
    }

    // chatUser.unreadCount = 3;

    return (
      <div
        className={`${
          isDisplay ? "d-flex" : "d-none"
        }  flex-row justify-content-between align-items-center cursor_pointer cursor_pointer_bg_light position-relative py-2 px-3`}
      >
        <div
          className="flex-fill d-flex flex-row align-items-center"
          onClick={() => addActiveChRoom(chat)}
        >
          <div
            className="position-relative d-flex flex-row align-items-center justify-content-center flex-wrap mr-1"
            style={{ width: 50, height: 50 }}
          >
            {userList.length > 2 && userList.length !== 3 && (
              <div className="w-100 h-100 d-flex flex-row flex-wrap">
                {userList.map((userPic, index) => {
                  return (
                    <div
                      key={index}
                      className="border border-white"
                      style={{
                        borderRadius: "45%",
                        background: `url(${userPic.UserPIC}) 50% 50%/cover no-repeat`,
                        width: "50%",
                        height: "50%",
                        marginLeft:
                          index + 1 === userList.length && userList.length === 3
                            ? "25%"
                            : "unset",
                      }}
                    />
                  );
                })}
              </div>
            )}

            {userList.length > 2 && userList.length === 3 && (
              <div className="w-100 h-100 d-flex flex-row flex-wrap">
                {userList.map((userPic, index) => {
                  return (
                    <div
                      key={index}
                      className="border border-white"
                      style={{
                        borderRadius: "45%",
                        background: `url(${userPic.UserPIC}) 50% 50%/cover no-repeat`,
                        width: "50%",
                        height: "50%",
                        marginLeft: index === 0 ? "25%" : "unset",
                      }}
                    />
                  );
                })}
              </div>
            )}

            {userList.length <= 2 && (
              <div
                className="w-100 h-100 border"
                style={{
                  borderRadius: "45%",
                  background: `url(${userList[0].UserPIC}) #fff 50% 50% / cover no-repeat`,
                  width: 50,
                  height: 50,
                }}
              />
            )}
            {userList.length === 0 && (
              <div
                className="w-100 h-100 border"
                style={{
                  borderRadius: "45%",
                  background: `url(${chatUser.UserPIC}) #fff 50% 50% / cover no-repeat`,
                  width: 50,
                  height: 50,
                }}
              />
            )}
          </div>
          <div className="px-2 flex-grow-1">
            <div className="d-flex flex-row  align-items-center">
              <div className="font-weight-bold m-0 p-0 d-flex flex-row justify-content-start">
                <div className="text-truncate" style={{ maxWidth: 230 }}>
                  {Number(chat.crmType) !== 1 && (
                    <span className="rounded-pill bg-light d-inline-block p-1 mr-1 font-size-06">
                      <i className="fa-solid fa-user-group" />{" "}
                      {chat.chatUserList.length}
                    </span>
                  )}
                  {loginInfo.selfChatRoomKey === chat.crmMainKey && (
                    <span
                      className="d-inline-flex flex-row justify-content-center align-items-center bg-secondary text-white text-center rounded-circle mr-1 font-size-07"
                      style={{
                        width: 16,
                        height: 16,
                      }}
                    >
                      {t("logiTalk.chatList.me")}
                    </span>
                  )}
                  {chat.chatRoomTitle}
                </div>
              </div>
              {alertDisabledList.hasOwnProperty(chat.crmMainKey) && (
                <i className="far fa-bell-slash ml-1 text-danger" />
              )}
            </div>
            <p
              className="m-0 font-size-09"
              style={{
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                wordBreak: "keep-all",
              }}
            >
              {chatUser.cruAgreeYN === "Y" ? chat.crmLastMSG : msg}
            </p>

            <p className="m-0 font-size-08">{displayTime}</p>
          </div>
        </div>
        <div className="align-self-start position-relative">
          <i
            className="fa-solid fa-ellipsis-vertical cursor_pointer px-1"
            onClick={() => setIsOpenMenu(true)}
          />
          {isOpenMenu && (
            <>
              <div
                className="position-absolute bg-white rounded shadow-sm overflow-hidden"
                style={{ minWidth: 120, zIndex: 4, top: 0, right: 0 }}
              >
                <p
                  className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                  onClick={() => {
                    const type = alertDisabledList.hasOwnProperty(
                      chat.crmMainKey
                    )
                      ? "DELETE"
                      : "INSERT";
                    updateAlertDisable(type, chat);
                    setIsOpenMenu(false);
                  }}
                >
                  {t("logiTalk.chatList.alarm")}{" "}
                  {alertDisabledList.hasOwnProperty(chat.crmMainKey)
                    ? t("logiTalk.chatList.on")
                    : t("logiTalk.chatList.off")}
                </p>
                <p
                  className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                  data-toggle="modal"
                  data-target="#ChangeChatRoomTitleModal"
                  onClick={() => {
                    openChangeChatRoomTitleModal(chat);
                    setIsOpenMenu(false);
                  }}
                >
                  {t("logiTalk.chatList.changeChatRoomTitle")}
                </p>
                {chat.crmType === "2" && (
                  <p
                    className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                    onClick={() => EVENT_SOCKET_TALK_LEAVE_ROOM(chat)}
                  >
                    {t("logiTalk.chatList.leave")}
                  </p>
                )}
              </div>
              <div
                className="vw-100 vh-100 position-fixed cursor_pointer"
                style={{
                  top: 0,
                  left: 0,
                  zIndex: 3,
                  background: "rgba(0,0,0,0.1)",
                }}
                onClick={() => setIsOpenMenu(false)}
              />
            </>
          )}
        </div>

        {!Boolean(chatUser.lastReadIDX) && !Boolean(chatUser.unreadCount) && (
          <div
            className="d-inline-block rounded-pill position-absolute px-1 d-flex flex-row justify-content-center align-items-center font-weight-bold bg-info text-white font-size-06"
            style={{
              height: 16,
              right: "0.85rem",
              bottom: "0.85rem",
            }}
          >
            NEW
          </div>
        )}

        {chatUser.unreadCount > 0 && (
          <div
            className="d-inline-block rounded-circle position-absolute d-flex flex-row justify-content-center align-items-center font-weight-bold bg-info text-white font-size-07"
            style={{
              width: 16,
              height: 16,
              right: "0.85rem",
              bottom: "0.85rem",
            }}
          >
            {chatUser.unreadCount > 9 ? `+9` : chatUser.unreadCount}
          </div>
        )}
      </div>
    );
  }
}
